import { render, staticRenderFns } from "./WBKlassifizierungCell.vue?vue&type=template&id=0a7818f6&scoped=true&"
import script from "./WBKlassifizierungCell.vue?vue&type=script&lang=js&"
export * from "./WBKlassifizierungCell.vue?vue&type=script&lang=js&"
import style0 from "./WBKlassifizierungCell.vue?vue&type=style&index=0&id=0a7818f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7818f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VCard,VCardText,VIcon,VSheet,VTextField,VTreeview})
